import { db } from "../../firebase/firebase";
import revealData from '../../util/revealData';
import moment from "moment";

export const getAffiliationRequestsRequest = async (userId) => {
  try {
    let affiliationRequests = [];
    let raw = [];
    await db.ref(`affiliationRequest/${userId}`).once('value', snap => {
      affiliationRequests = snap.val() ? Object.values(snap.val()) : []
    });

    if(affiliationRequests.length > 0) {
      await affiliationRequests.forEach(async (affiliationRequest, index) => {
       await db.ref(`users/${affiliationRequest.targetId}`).once('value', async snap => {
         let user = await snap.val();
          raw.push({
            ...affiliationRequest,
            userData: {
              ...user,
            },
          });
        });
      });
    }
    return await revealData(raw);
  } catch (error) {
    return error;
  }
}

export const deleteAffiliationRequestRequest = async (targetId, affiliationId, userId) => {
  try {
    await db.ref(`affiliationRequest/${ userId }/${ affiliationId }`).remove();
    await db.ref(`affiliationRequest/${ targetId }/${ affiliationId }`).remove();
  } catch (error) {
    return error
  }
}

export const addAffiliationRequestRequest = async (targetId, userId) => {
  try {
    const getMutualObject = (id) => ({
      date: moment().format('DD-MM-YYYY'),
      time: moment().format('hh:mm'),
      senderId: userId,
      id
    })
    const newRef = await db.ref(`affiliationRequests/${ userId }/`).push();
    await db.ref(`affiliationRequest/${ userId }/${ newRef.key }`).set({
      ...getMutualObject(newRef.key),
      targetId,
      userId
    });
    await db.ref(`affiliationRequest/${ targetId }/${ newRef.key }`).set({
      ...getMutualObject(newRef.key),
      userId: targetId,
      targetId: userId,
    });
  } catch (error) {
    return error
  }
}
